import request from '@/utils/request'


// 查询挂号记录列表
export function listRegistRecord(query) {
  return request({
    url: '/user/registRecord/list',
    method: 'get',
    params: query
  })
}

// 查询挂号记录分页
export function pageRegistRecord(query) {
  return request({
    url: '/user/registRecord/page',
    method: 'get',
    params: query
  })
}

// 查询挂号记录详细
export function getRegistRecord(data) {
  return request({
    url: '/user/registRecord/detail',
    method: 'get',
    params: data
  })
}

// 新增挂号记录
export function addRegistRecord(data) {
  return request({
    url: '/user/registRecord/add',
    method: 'post',
    data: data
  })
}

// 修改挂号记录
export function updateRegistRecord(data) {
  return request({
    url: '/user/registRecord/edit',
    method: 'post',
    data: data
  })
}

// 删除挂号记录
export function delRegistRecord(data) {
  return request({
    url: '/user/registRecord/delete',
    method: 'post',
    data: data
  })
}
